import __request__ from "routing/request";
export function getStatus() {
  return __request__("GET", "/cluster/processing/status", null, {}, {
    "Accept": ["application/json"]
  });
}
export function getPersistedStatus() {
  return __request__("GET", "/cluster/processing/status/persisted", null, {}, {
    "Accept": ["application/json"]
  });
}
